import React from 'react'
import { styled } from 'linaria/react'
import { useIntl } from '@jetshop/intl'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'
import { getStringByPropertyName } from '../../Core/Util/Helpers'
import SiteButton from '../../Core/SiteButton'
import { NavArrowRight } from 'iconoir-react'
import { theme } from '../../Theme'
import Link from '../../Core/Link'
import { htmlStringIsValid } from '../../Core/Util/BannerHelpers'
import { stringByPropertyNameHasValidValue } from '../../Core/Util/Helpers'

const AboutBrandWrapper = styled.div`
   .description-content {
      h1 {
         font-size: 21px !important;
      }
      h2 {
         font-size: 20px !important;
      }
      h3 {
         font-size: 19px !important;
      }
      h4 {
         font-size: 18px !important;
      }
   }
`
const LogoWrapper = styled.div`
   ${theme.below.sm} {
      img {
         max-height: 80px;
         margin-bottom: ${theme.spacing.xxs};
      }
   }
`

const ManufacturerInformationContainer = styled.div`
   .manufacturer-information .list-group-item {
      border: 0;
      border-radius: 0;
      border-bottom-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
      background-color: transparent;
   }

   .manufacturer-information .list-group .list-group-item:first-child {
      font-weight: 700;
      font-family: var(--font-industry);
      text-transform: uppercase;
      width: 30%;
      min-width: 12rem;
   }

   .manufacturer-information .list-group .list-group-item:last-child {
      width: 70%;
   }

   .manufacturer-information .list-group:nth-child(odd) li {
      background: var(--color-vb-gray-2) !important;
   }

   ul {
      padding: unset;
      margin: unset;
      list-style: none;
   }

   a {
      color: var(--color-vb-blue);
   }

   @media (max-width: 768px) {
      .list-group li {
         width: 50% !important;
      }
      .list-group-item:last-child {
         padding-left: 0;
      }
   }
`

const truncate = (str, n = 30) =>
   str && str.length > n ? str.slice(0, n) + '…' : str;

const ProductAboutBrand = ({ brand, brandSupplierInfo }) => {
   const t = useIntl()
   const brandProps = brand?.data?.items?.find(
      comp => comp?.type == VB_CATEGORY_SETTINGS
   )?.properties
   const brandText = getStringByPropertyName(brandProps, 'description')
   const htmlContent = getStringByPropertyName(brandProps, 'customContent')
   const brandLink = brand?.primaryRoute?.path
   const hasEmail = brandSupplierInfo?.email && brandSupplierInfo?.email !== '';
   const manufacturerInformation = [
      { label: t('Manufacturer'), value: brandSupplierInfo?.name || '', fieldType: 'text' },
      { label: t('Manufacturer address'), value: brandSupplierInfo?.address || '', fieldType: 'text' },
      { label: t('Contact manufacturer'), value: hasEmail ? brandSupplierInfo?.email : brandSupplierInfo?.website, fieldType: hasEmail ? 'email' : 'website' },
   ]

   const getDescription = (htmlContent, text) => {
      if (htmlStringIsValid(htmlContent)) {
         return (
            <div
               className="description-content"
               dangerouslySetInnerHTML={{
                  __html: htmlContent,
               }}
            />
         )
      } else if (stringByPropertyNameHasValidValue(text)) {
         return <p>{text}</p>
      } else {
         return <></>
      }
   }

   const description = getDescription(htmlContent, brandText)

   return (
      <AboutBrandWrapper className="row">
         {brand?.images?.length > 0 && (
            <div className="col-sm-2">
               <LogoWrapper>
                  <Link to={brandLink}>
                     <img
                        className="img-fluid"
                        src={brand?.images[0]?.url}
                        alt={brand?.name}
                     ></img>
                  </Link>
               </LogoWrapper>
            </div>
         )}
         <div className="col-sm-10">
            {description}
            <SiteButton
               className="mt-16 py-8 px-16"
               styleType="solid"
               color="blue"
               icon={true}
               href={brandLink}
            >
               {brandLink && (
                  <span>
                     {t('see all products')} {brand?.name}
                  </span>
               )}
               <NavArrowRight
                  strokeWidth={2.0}
                  style={{ marginLeft: '2.3rem' }}
               ></NavArrowRight>
            </SiteButton>
            <ManufacturerInformationContainer className="mt-16">
               <div className="manufacturer-information">
                  <>
                     {manufacturerInformation?.map((spec, index) => {
                        return (
                           <ul
                              key={index}
                              className="spec-row list-group list-group-horizontal"
                           >
                              <li className="list-group-item">
                                 {spec?.label}:
                              </li>
                              <li className="list-group-item">
                                 {spec?.fieldType === 'email' ? (
                                    <a
                                       className="link link--vb"
                                       href={`mailto:${spec.value}`}
                                    >
                                       {spec.value}
                                    </a>
                                 ) : spec?.fieldType === 'website' ? (
                                    <a
                                       href={spec?.value?.startsWith('http') ? spec?.value : `https://${spec?.value}`}
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       className="link link--vb"
                                    >
                                       {truncate(spec?.value)}
                                    </a>
                                 ) : (
                                    spec?.value
                                 )}
                              </li>
                           </ul>
                        )
                     })}
                  </>
               </div>
            </ManufacturerInformationContainer>
         </div>
      </AboutBrandWrapper>
   )
}

export default ProductAboutBrand
